import React, { useState } from 'react';
import { Col, Container, Row, Button } from 'react-bootstrap';
import { BrandsItem } from './BrandsItem';
import { useBrands } from './useBrands';

const Brands = () => {
  const { brands, createBrand, showNew, setShowNew } = useBrands();
  const [error, setError] = useState<string>('');

  const handleCreateBrand = async (props: { name: string }) => {
    setError('');
    try {
      await createBrand(props);
    } catch (err: any) {
      setError(err.message || 'Ошибка при создании бренда');
    }
  };

  return (
    <Container>
      <Row>
        <Col>
          <Button
            style={{ margin: '16px 0' }}
            onClick={() => {
              setShowNew(!showNew);
              setError('');
            }}
          >
            {!showNew ? 'Создать бренд' : 'Скрыть форму'}
          </Button>
        </Col>
      </Row>
      <Row>
        <Col>
          {showNew && (
            <BrandsItem onCreateBrand={handleCreateBrand} error={error} />
          )}
          {brands.map((el, index) => (
            <Row
              key={index}
              style={{
                marginBottom: 8,
                padding: 12,
                border: '1px solid #eee',
                backgroundColor: '#f9f9f9',
              }}
            >
              <Col>{el.name}</Col>
            </Row>
          ))}
          {!brands.length && <div>Нет созданных брендов</div>}
        </Col>
      </Row>
    </Container>
  );
};

export default Brands;
